// extracted by mini-css-extract-plugin
export default {"gallery":"Gallery_gallery__lOXTt","draggable-block":"Gallery_draggable-block__PFSnp"};